import { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { headline2, headline3 } from "@shared/styles";
import AddEmailSection from "../ModalSections/AddEmailSection";
import AddPhoneSection from "../ModalSections/AddPhoneSection";
import AddAddressSection from "../ModalSections/AddAddressSection";
import FieldTextV1 from "../../shared/UtilsV1/FieldTextV1";
import { containerView } from "./styles";
import { setPersonValue } from "../../reducers/contactsReducer";
import { useContactFormOptions, useContactPerson } from "../../reducers/contactsReducer/selectors";

function ContactInfoView({ modalType }) {
  const dispatch = useDispatch();
  const formOptions = useContactFormOptions();
  const person = useContactPerson();

  useEffect(() => {
    if (person.id) return;
    if (person.firstName) {
      dispatch(setPersonValue({ key: "letterSalutation", value: `Dear ${person.firstName}` }));
    }
    if (person.firstName && person.lastName) {
      dispatch(
        setPersonValue({ key: "envelopeSalutation", value: `${person.firstName} ${person.lastName}` }),
      );
    }
  }, [person.id, person.firstName, person.lastName]);

  return (
    <div className={containerView}>
      <div className={` tw-text-neutral-gray-75 ${headline2}`}>Contact Info</div>
      <div className={headline3}>Email Addresses</div>

      <AddEmailSection
        emailDetails={person.emailDetailsAttributes}
        isDisplayByDefault={!person?.id}
        modalType={modalType}
        required={modalType === "user" || modalType === "websiteProfile" || modalType === "lender"}
        setPersonValue={(...args) => dispatch(setPersonValue(...args))}
      />
      <hr className="tw-w-full tw-border-gray-10 tw-m-0" />
      <AddPhoneSection
        phoneList={person.phoneDetailsAttributes}
        isDisplayByDefault={modalType === "lead" && !person?.id}
        setPersonValue={(...args) => dispatch(setPersonValue(...args))}
        personId={person.id ? String(person.id) : ""}
        modalType={modalType}
      />
      <AddAddressSection
        modalType={modalType}
        isDisplayByDefault={modalType === "lead" && !person?.id}
        addressList={person.addressesAttributes}
        setPersonValue={(...args) => dispatch(setPersonValue(...args))}
        stateOptions={formOptions?.stateOptions}
      />

      {person.id && (
        <div className="tw-flex tw-gap-[24px]">
          <FieldTextV1
            label="Letter Salutation"
            value={person.letterSalutation}
            onChange={(value) => dispatch(setPersonValue({ key: "letterSalutation", value }))}
          />
          <FieldTextV1
            label="Envelope Salutation"
            value={person.envelopeSalutation}
            onChange={(value) => dispatch(setPersonValue({ key: "envelopeSalutation", value }))}
          />
        </div>
      )}
    </div>
  );
}

ContactInfoView.propTypes = { modalType: PropTypes.string.isRequired };

export default ContactInfoView;
